export { default } from "./routes/professional_article/main/index.tsx";